import { IStore } from '../interfaces/Store';
import Client from './client';

class StoreApi {
  private static classInstance?: StoreApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new StoreApi();
    }
    return this.classInstance;
  }

  public listStores(): Promise<IStore[]> {
    return Client.get('/store');
  }

  public listStoresForSeller(sellerId: string): Promise<IStore[]> {
    return Client.get(`/store/for-seller/${sellerId}`);
  }

  public createStore(body: { name: string }): Promise<IStore> {
    return Client.post('/store', body);
  }

  public updateStore(id: string, body: { name: string }): Promise<IStore> {
    return Client.patch(`/store/${id}`, body);
  }

  public deleteStore(id: string): Promise<{ success: true }> {
    return Client.delete(`/store/${id}`);
  }
}

export default StoreApi.instance;
